
.pb,
.pb *,
.pb *::before,
.pb *::after {
  box-sizing: border-box;
}

.pb {
  position: relative;
  background: #ffffff;
  color: #0a0a0a;
  font-family: "Rajdhani", Arial, sans-serif;
  overflow: hidden;
  scroll-margin-top: 80px;
}

.pb-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.pb-header {
  text-align: left;
  max-width: 720px;
  margin: 0 0 3rem 0;
}

.pb-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  font-weight: 600;
  font-size: 0.8rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #de3431;
  margin-bottom: 1.25rem;
}

.pb-eyebrow-mark {
  width: 28px;
  height: 2px;
  background: #de3431;
  border-radius: 2px;
  display: inline-block;
}

.pb-title {
  margin: 0 0 1rem 0;
  font-weight: 700;
  font-size: clamp(2rem, 3.5vw, 2.5rem);
  letter-spacing: -0.025em;
  line-height: 1.1;
  color: #0a0a0a;
}

.pb-title-accent {
  background: linear-gradient(135deg, #de3431 0%, #ff6b5a 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
}

.pb-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.75rem;
}

.pb-card {
  position: relative;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  color: inherit;
  background: #ffffff;
  border: 1px solid rgba(10, 10, 10, 0.08);
  border-radius: 14px;
  overflow: hidden;
  transition: border-color 0.25s ease, box-shadow 0.25s ease, transform 0.25s ease;
  box-shadow: 0 2px 12px rgba(10, 10, 10, 0.04);
  cursor: pointer;
}

.pb-card:hover,
.pb-card:focus-visible {
  border-color: rgba(222, 52, 49, 0.45);
  box-shadow: 0 18px 38px rgba(222, 52, 49, 0.12), 0 4px 14px rgba(10, 10, 10, 0.06);
  transform: translateY(-4px);
}

.pb-card-image-wrap {
  position: relative;
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #f7f7f9 0%, #ececf0 100%);
  overflow: hidden;
}

.pb-card-glow {
  position: absolute;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, rgba(222, 52, 49, 0.18) 0%, rgba(222, 52, 49, 0) 70%);
  filter: blur(20px);
  opacity: 0;
  transition: opacity 0.35s ease;
  pointer-events: none;
}

.pb-card:hover .pb-card-glow,
.pb-card:focus-visible .pb-card-glow {
  opacity: 1;
}

.pb .pb-card-image {
  position: relative;
  z-index: 1;
  max-width: 70%;
  max-height: 88%;
  width: auto;
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 14px 26px rgba(10, 10, 10, 0.18));
  transition: transform 0.35s ease;
}

.pb-card:hover .pb-card-image,
.pb-card:focus-visible .pb-card-image {
  transform: scale(1.04);
}

.pb-card-body {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem 1.6rem 1.6rem;
  flex: 1;
}

.pb-card-text {
  display: flex;
  flex-direction: column;
}

.pb-card-name {
  margin: 0;
  font-size: 1.35rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0a0a0a;
  line-height: 1.2;
}

.pb-card-tagline {
  margin: 0.25rem 0 0.7rem 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #de3431;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.pb-card-blurb {
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
  color: #4a4a55;
  font-weight: 500;
}

.pb-card-cta {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: auto;
  padding: 0.7rem 1.4rem;
  background: #de3431;
  color: #ffffff;
  font-family: "Rajdhani", Arial, sans-serif;
  font-weight: 700;
  font-size: 0.9rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  border: 2px solid #de3431;
  border-radius: 4px;
  transition: background 0.2s ease, color 0.2s ease, border-color 0.2s ease;
}

.pb-card:hover .pb-card-cta,
.pb-card:focus-visible .pb-card-cta {
  background: #0a0a0a;
  border-color: #0a0a0a;
}

.pb-card-cta-arrow {
  display: inline-block;
  transition: transform 0.2s ease;
}

.pb-card:hover .pb-card-cta-arrow,
.pb-card:focus-visible .pb-card-cta-arrow {
  transform: translateX(3px);
}

@media (max-width: 820px) {
  .pb-grid {
    grid-template-columns: 1fr;
    gap: 1.25rem;
  }

  .pb-header {
    margin-bottom: 2rem;
  }

  .pb-card-image-wrap {
    height: 240px;
  }
}

@media (max-width: 480px) {
  .pb-card-image-wrap {
    height: 200px;
  }

  .pb-card-body {
    padding: 1.25rem 1.25rem 1.4rem;
    gap: 1rem;
  }

  .pb-card-name {
    font-size: 1.2rem;
  }

  .pb-card-blurb {
    font-size: 0.95rem;
  }
}
